// extracted by mini-css-extract-plugin
export var equalColumn = "_io-0";